import React from "react";
import { Form, Input, Select } from "antd";

export default function FiberOpticForm({ title }) {
  return (
    <>
      <h3>{title}</h3>
      <Form.Item name="markLenght" label="Mark Lenght">
        <Input.Group compact>
          <Form.Item
            name={["markLenght", "v1"]}
            style={{ display: "inline-block", width: "calc(50% - 4%)" }}
          >
            <Input></Input>
          </Form.Item>
          <Form.Item
            name={["markLenght", "v2"]}
            style={{
              display: "inline-block",
              width: "calc(50% - 4%)",
              margin: "0 4%",
            }}
          >
            <Input></Input>
          </Form.Item>
        </Input.Group>
      </Form.Item>
      <Form.Item name="cableType" label="ประเภทสาย">
        <Select>
          <Select.Option>Test</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item name="cableDistance" label="ระยะสายที่ใช้">
        <Input></Input>
      </Form.Item>
      <Form.Item name="fiberRemark" label="หมายเหตุ">
        <Input.TextArea rows="5"></Input.TextArea>
      </Form.Item>
    </>
  );
}
